<template>
  <Toaster></Toaster>
  <Dialog :open="openModal" @update:open="openModal = $event">
    <DialogContent>
      <DialogHeader>
        <DialogTitle>
          {{
            model.dataCollectionLocation.translations[
              "registerTree.Form.Location.InvalidDistance.Header"
            ]
          }}
        </DialogTitle>
        <DialogDescription>
          {{
            model.dataCollectionLocation.translations[
              "registerTree.Form.Location.InvalidDistance.Body"
            ]
          }}
        </DialogDescription>
      </DialogHeader>
      <DialogFooter>
        <DialogClose as-child>
          <Button type="button">
            {{
              model.dataCollectionLocation.translations[
                "registerTree.Form.Location.InvalidDistance.Button"
              ]
            }}
          </Button>
        </DialogClose>
      </DialogFooter>
    </DialogContent>
  </Dialog>
  <div class="form-wrapper" ref="formSection">
    <div class="charity-info">
      <div class="title-wrapper">
        <h5>
          {{ model.translations["registerTree.ChristmasCollectionPrefix"] }}
          {{ currentHospice?.name }}
        </h5>
        <div class="image-wrapper">
          <img v-if="currentHospice?.logo" :src="currentHospice.logo" :alt="currentHospice.name" />
        </div>
      </div>
      <p v-html="description"></p>
      <p>
        {{ model.translations["registerTree.ChristmasCollectionGreatNews"] }}
        <span>
          {{ localDate(currentHospice?.collectionDateStart) }} -
          {{ localDate(currentHospice?.collectionDateEnd) }}</span
        >
      </p>
    </div>
    <form @submit.prevent="onSubmit" class="register-tree-form" id="register-tree-form">
      <h5>
        {{ model.dataCollectionLocation.title }}
      </h5>
      <div class="field-group">
        <div class="field-address">
          <FormField v-slot="{ componentField }" name="shippingDetails.postCode">
            <FormItem>
              <FormControl>
                <Input type="text" placeholder="Details" v-bind="componentField" disabled />
              </FormControl>
              <FormMessage />
            </FormItem>
          </FormField>
          <FormField
            v-slot="{ componentField }"
            name="addressSelect"
            v-if="addressSuggestions?.count"
          >
            <FormItem>
              <FormControl>
                <Select v-bind="componentField">
                  <FormControl>
                    <SelectTrigger class="w-full">
                      <SelectValue placeholder="Select Address" />
                    </SelectTrigger>
                  </FormControl>
                  <SelectContent>
                    <SelectGroup>
                      <SelectLabel>Adresses</SelectLabel>
                      <SelectItem v-for="item in addressSuggestions.results" :value="item.format">
                        {{ item.suggestion }}
                      </SelectItem>
                    </SelectGroup>
                  </SelectContent>
                </Select>
              </FormControl>
              <FormMessage />
            </FormItem>
          </FormField>
          <template v-if="(selectedAdress && !isManualFlow) || isManualFlow">
            <FormField
              v-slot="{ componentField }"
              name="shippingDetails.addressLine1"
              v-if="addressSuggestions?.count"
            >
              <FormItem>
                <FormControl>
                  <Input
                    type="text"
                    :placeholder="
                      model.dataCollectionLocation.translations['generic.Address.AddressLine1']
                    "
                    :disabled="!isManualFlow"
                    v-bind="componentField"
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            </FormField>
            <FormField
              v-slot="{ componentField }"
              name="shippingDetails.addressLine2"
              v-if="addressSuggestions?.count"
            >
              <FormItem>
                <FormControl>
                  <Input
                    type="text"
                    :placeholder="
                      model.dataCollectionLocation.translations['generic.Address.AddressLine2']
                    "
                    :disabled="!isManualFlow"
                    v-bind="componentField"
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            </FormField>
            <FormField
              v-slot="{ componentField }"
              name="shippingDetails.addressLine3"
              v-if="addressSuggestions?.count"
            >
              <FormItem>
                <FormControl>
                  <Input
                    type="text"
                    :placeholder="
                      model.dataCollectionLocation.translations['generic.Address.AddressLine3']
                    "
                    :disabled="!isManualFlow"
                    v-bind="componentField"
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            </FormField>
            <FormField
              v-slot="{ componentField }"
              name="shippingDetails.locality"
              :disabled="!isManualFlow"
              v-if="addressSuggestions?.count"
            >
              <FormItem>
                <FormControl>
                  <Input
                    type="text"
                    :placeholder="
                      model.dataCollectionLocation.translations['generic.Address.Locality']
                    "
                    :disabled="!isManualFlow"
                    v-bind="componentField"
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            </FormField>
          </template>
          <FormField
            v-slot="{ componentField }"
            name="shippingDetails.what3Words"
            v-if="addressSuggestions?.count"
            :validate-on-model-update="false"
          >
            <FormItem>
              <FormControl>
                <Input
                  type="text"
                  placeholder="Please enter your trees what3words location (if known)"
                  v-bind="componentField"
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          </FormField>
        </div>
        <GoogleMap
          :api-key="mapKey"
          :map-id="MAP_ID"
          :center="mapCenter"
          :zoom="mapZoom"
          class="google-map"
          :map-type-control="false"
          @click="setMarker"
        >
          <AdvancedMarker v-if="markerPosition" :options="markerOptions" @dragend="setMarker">
          </AdvancedMarker>
        </GoogleMap>
      </div>
      <div class="form-section">
        <h2>{{ model.dataCollectionPersonalDetails.title }}</h2>
        <div class="field-group">
          <FormField v-slot="{ componentField }" name="personalDetails.title">
            <FormItem>
              <FormControl>
                <Select v-bind="componentField">
                  <FormControl>
                    <SelectTrigger class="w-full">
                      <SelectValue
                        :placeholder="
                          model.dataCollectionPersonalDetails.translations[
                            'generic.PersonalDetails.Title'
                          ]
                        "
                      />
                    </SelectTrigger>
                  </FormControl>
                  <SelectContent>
                    <SelectGroup>
                      <SelectLabel>
                        {{
                          model.dataCollectionPersonalDetails.translations[
                            "generic.PersonalDetails.Title"
                          ]
                        }}
                      </SelectLabel>
                      <SelectItem
                        v-for="item in model.dataCollectionPersonalDetails.titles"
                        :value="item.value"
                      >
                        {{ item.text }}
                      </SelectItem>
                    </SelectGroup>
                  </SelectContent>
                </Select>
              </FormControl>
              <FormMessage />
            </FormItem>
          </FormField>
          <FormField v-slot="{ componentField }" name="personalDetails.firstName">
            <FormItem>
              <FormControl>
                <Input
                  type="text"
                  :placeholder="
                    model.dataCollectionPersonalDetails.translations[
                      'generic.PersonalDetails.FirstName'
                    ]
                  "
                  v-bind="componentField"
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          </FormField>
          <FormField v-slot="{ componentField }" name="personalDetails.lastName">
            <FormItem>
              <FormControl>
                <Input
                  type="text"
                  :placeholder="
                    model.dataCollectionPersonalDetails.translations[
                      'generic.PersonalDetails.LastName'
                    ]
                  "
                  v-bind="componentField"
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          </FormField>
        </div>
        <div class="field-group">
          <FormField v-slot="{ componentField }" name="personalDetails.phone">
            <FormItem>
              <FormControl>
                <VueTelInput
                  :inputOptions="{
                    placeholder:
                      model.dataCollectionPersonalDetails.translations[
                        'generic.PersonalDetails.PhoneNumber'
                      ],
                  }"
                  :onlyCountries="['GB']"
                  v-bind="componentField"
                  class="input"
                  defaultCountry="GB"
                  @validate="onPhoneValidate"
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          </FormField>
          <FormField v-slot="{ componentField }" name="personalDetails.email">
            <FormItem>
              <FormControl>
                <Input
                  type="text"
                  :placeholder="
                    model.dataCollectionPersonalDetails.translations[
                      'generic.PersonalDetails.Email'
                    ]
                  "
                  v-bind="componentField"
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          </FormField>
          <FormField v-slot="{ componentField }" name="personalDetails.emailConfirmation">
            <FormItem>
              <FormControl>
                <Input
                  type="text"
                  :placeholder="
                    model.dataCollectionPersonalDetails.translations[
                      'generic.PersonalDetails.EmailConfirmation'
                    ]
                  "
                  v-bind="componentField"
                  @paste.prevent
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          </FormField>
        </div>
      </div>
      <div class="form-section">
        <h2>{{ model.trees.title }}</h2>
        <FormField v-slot="{ componentField }" name="numberOfTrees">
          <FormItem>
            <FormControl>
              <Select v-bind="componentField">
                <FormControl>
                  <SelectTrigger class="w-full">
                    <SelectValue
                      :placeholder="model.trees.translations['registerTree.Trees.NumberOfTrees']"
                    />
                  </SelectTrigger>
                </FormControl>
                <SelectContent>
                  <SelectGroup>
                    <SelectLabel
                      >{{ model.trees.translations["registerTree.Trees.NumberOfTrees"] }}
                    </SelectLabel>
                    <SelectItem v-for="item in treesOptions" :value="item.value">
                      {{ item.text }}
                    </SelectItem>
                  </SelectGroup>
                </SelectContent>
              </Select>
            </FormControl>
            <FormMessage />
          </FormItem>
        </FormField>
        <FormField v-slot="{ componentField }" name="itemsToCollect.otherDetails">
          <FormItem>
            <FormControl>
              <Textarea
                type="text"
                :placeholder="model.trees.translations['registerTree.Trees.OtherDetails']"
                v-bind="componentField"
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        </FormField>
        <FormField v-slot="{ value, handleChange }" name="isBigTree">
          <FormItem class="checkbox-field">
            <FormControl>
              <Checkbox :model-value="value" @update:model-value="handleChange" />
            </FormControl>
            <FormMessage />
            <FormLabel v-if="form.values.numberOfTrees ?? 0 > 1">
              {{ model.trees.translations["registerTree.Trees.SizeOfTreePlular"] }}
            </FormLabel>
            <FormLabel v-else>
              {{ model.trees.translations["registerTree.Trees.SizeOfTree"] }}
            </FormLabel>
          </FormItem>
        </FormField>
      </div>
      <div class="form-section">
        <h2>{{ model.keepInTouch.keepInTouchData.title }}</h2>
        <div v-html="model.keepInTouch.keepInTouchData.description"></div>
        <FormField
          v-if="model.keepInTouch.keepInTouchData.checkboxDescription"
          v-slot="{ value, handleChange }"
          name="contactMethods.selectedContactCheckbox"
          :unchecked-value="false"
          type="checkbox"
        >
          <FormItem class="checkbox-field">
            <FormControl>
              <Checkbox :model-value="value" @update:model-value="handleChange" />
            </FormControl>
            <FormMessage />
            <FormLabel>
              <span v-html="model.keepInTouch.keepInTouchData.checkboxDescription"></span>
            </FormLabel>
          </FormItem>
        </FormField>
        <FormField
          v-if="model.keepInTouch.keepInTouchData.hospiceCheckboxDescription"
          v-slot="{ value, handleChange }"
          name="contactMethods.selectedHospiceContactCheckbox"
          :unchecked-value="false"
          type="checkbox"
        >
          <FormItem class="checkbox-field">
            <FormControl>
              <Checkbox :model-value="value" @update:model-value="handleChange" />
            </FormControl>
            <FormMessage />
            <FormLabel>
              <span v-html="model.keepInTouch.keepInTouchData.hospiceCheckboxDescription"></span>
            </FormLabel>
          </FormItem>
        </FormField>
        <template v-if="model.keepInTouch.keepInTouchData.leadSources.length">
          <h3>{{ model.keepInTouch.keepInTouchData.leadSourceTitle }}</h3>
          <FormField v-slot="{ componentField }" name="contactMethods.leadSource">
            <FormItem>
              <FormControl>
                <Select v-bind="componentField">
                  <FormControl>
                    <SelectTrigger class="select-keep-in-touch">
                      <SelectValue
                        :placeholder="model.keepInTouch.translations['generic.Select']"
                      />
                    </SelectTrigger>
                  </FormControl>
                  <SelectContent>
                    <SelectGroup>
                      <SelectItem v-for="item in model.keepInTouch.leadSources" :value="item.value">
                        {{ item.text }}
                      </SelectItem>
                    </SelectGroup>
                  </SelectContent>
                </Select>
              </FormControl>
              <FormMessage />
            </FormItem>
          </FormField>
        </template>
      </div>
      <div class="form-section">
        <h2>{{ model.donation.title }}</h2>
        <CurrencyInput name="payment.prize" :options="CURRENCY_OPTIONS" />
        <div class="buttons-donation">
          <Button
            type="button"
            v-for="value in sortedDonationValues"
            @click="() => setDonationAmount(value.value)"
            >{{ value.text }}</Button
          >
        </div>
        <p v-if="!showPaymentOptions">
          {{ model.donation.translations["registerTree.Form.DonationsDonateNothingText"] }}
        </p>
        <div class="container-gift-aid" v-if="showPaymentOptions">
          <h2 class="container-gift-aid--title">{{ model.donation.giftAid.title }}</h2>
          <div class="container-gift-aid--subtitle" v-html="model.donation.giftAid.subtitle"></div>
          <FormField v-slot="{ value, handleChange }" name="payment.giftAid">
            <FormItem class="checkbox-field">
              <FormControl>
                <Checkbox :model-value="value" @update:model-value="handleChange" />
              </FormControl>
              <FormLabel>
                {{ model.donation.giftAid.consent }}
              </FormLabel>
              <FormMessage />
            </FormItem>
          </FormField>
          <div class="container-gift-aid--bottom-text" v-html="model.donation.giftAid.text"></div>
          <div
            class="container-gift-aid--explanation"
            v-html="model.donation.giftAid.explanatory"
          ></div>
        </div>
      </div>
      <div class="form-section" v-if="showPaymentOptions">
        <h2>{{ model.donation.translations["registerTree.Form.DonationsPaymentMethodTitle"] }}</h2>
        <FormField v-slot="{ value }" name="payment.paymentMethodId">
          <FormItem>
            <FormControl>
              <DonatePaymentMethods
                :value="value"
                @change="handlePaymentMethodChange"
                :options="paymentMethods?.paymentMethods"
              >
              </DonatePaymentMethods>
            </FormControl>
            <FormMessage />
          </FormItem>
        </FormField>
      </div>
      <FormField
        v-slot="{ value, handleChange }"
        name="contactMethods.selectedTandCCheckbox"
        :unchecked-value="false"
        type="checkbox"
      >
        <FormItem class="checkbox-field">
          <FormControl>
            <Checkbox :model-value="value" @update:model-value="handleChange" />
          </FormControl>
          <FormLabel>
            <span v-html="model.translations['registerTree.Form.TermsAndConditions']"></span>
          </FormLabel>
          <FormMessage />
        </FormItem>
      </FormField>
      <div class="buttons">
        <Button type="submit" :disabled="isSubmitting">
          {{
            (form.values.payment?.prize ?? 0 > 0)
              ? "Proceed to Checkout & Donate"
              : "Register Your Tree"
          }}
        </Button>
      </div>
    </form>
  </div>
</template>
<script lang="ts" setup>
import { getPaymentMethods } from "@/api/donate/donate.api"
import {
  getAddressSuggestionsByPostCode,
  IRegisterOrderRequest,
  registerOrder,
} from "@/api/registerTree"
import { getAdressDetails, getCoordinates } from "@/api/registerTree/registerTree.api"
import { ILocation } from "@/api/registerTree/registerTree.model"
import CurrencyInput from "@/components/CurrencyInput/CurrencyInput.vue"
import { Button } from "@/components/ui/button"
import { Checkbox } from "@/components/ui/checkbox"
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form"
import { Input } from "@/components/ui/input"
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"
import { Toaster } from "@/components/ui/sonner"
import { Textarea } from "@/components/ui/textarea"
import { MAP_ID } from "@/contants/constant"
import { IPaymentOption } from "@/views/Donate/components/DonatePaymentMethods/DonatePaymentMethods.model"
import DonatePaymentMethods from "@/views/Donate/components/DonatePaymentMethods/DonatePaymentMethods.vue"
import { useMutation, useQuery } from "@tanstack/vue-query"
import { toTypedSchema } from "@vee-validate/zod"
import { load, ReCaptchaInstance } from "recaptcha-v3"
import { useForm } from "vee-validate"
import { computed, inject, onMounted, ref, watch } from "vue"
import { toast } from "vue-sonner"
import { VueTelInput } from "vue-tel-input"
import { AdvancedMarker, GoogleMap } from "vue3-google-map"
import * as z from "zod"
import { DEFAULT_POST_CODE_DATA } from "../TreeRegistration.constant"
import { PostCodeDataKey } from "../TreeRegistration.model"
import {
  CURRENCY_OPTIONS,
  MAX_NUMBER_OF_TREES,
  NOTES_ALLOWED_CHARS_REGEX,
  UK_CENTER,
  UK_PHONE_ASCII_REGEX,
  WHAT_3_WORDS_REGEX,
} from "./RegistrationOpenForm.constant"
import { localDate, measureDistanceInMeters } from "./RegistrationOpenForm.helper"
import type { IRegistrationOpenFormProps } from "./RegistrationOpenForm.model"

const { model } = defineProps<IRegistrationOpenFormProps>()
let recaptcha: ReCaptchaInstance
const collectionLookup = inject(PostCodeDataKey, DEFAULT_POST_CODE_DATA)
const openModal = ref(false)
const formSection = ref<HTMLElement | null>(null)
const isManualFlow = ref(false)
const hasExactCoordinates = ref(false)
const markerPosition = ref<google.maps.LatLngLiteral | undefined>(undefined)
const markerOptions = computed<google.maps.marker.AdvancedMarkerElementOptions>(() => ({
  gmpDraggable: true,
  position: markerPosition.value,
  title: "Your tree collection location",
}))
const mapCenter = computed(() => markerPosition.value || UK_CENTER)
const mapZoom = computed(() => (markerPosition.value ? 17 : 5))
const initialCoordinates = ref<ILocation | null>(null)
const isPhoneValid = ref(true)

onMounted(() => {
  if (!model.summary.reCaptcha?.siteKey) {
    toast("Can't initialize captcha", { important: true })
    return
  }
  load(model.summary.reCaptcha?.siteKey ?? "").then(async (recaptchaInstance) => {
    recaptcha = recaptchaInstance
  })
  if (formSection.value) {
    formSection.value.scrollIntoView({ behavior: "smooth", block: "start" })
  }
})

const {
  data: addressSuggestions,
  isError,
  isFetched,
} = useQuery({
  queryKey: ["addressSuggestions", collectionLookup.postCode],
  queryFn: () => getAddressSuggestionsByPostCode({ postCode: collectionLookup.postCode.value }),
})
const { data: paymentMethods } = useQuery({
  queryKey: ["paymentMethods"],
  queryFn: () => getPaymentMethods(model.donation.initializePaymentUrl, { culture, currentPageId }),
})
const { mutate: createOrder } = useMutation({
  mutationFn: (data: IRegisterOrderRequest) => registerOrder(model.summary.createOrderUrl, data),
  onSuccess: (data) => {
    window.location.href = data.paymentUrl
  },
})
const { data: coordinates, isError: isGetManualCoordinatesError } = useQuery({
  queryKey: ["coordinates"],
  queryFn: () =>
    getCoordinates({
      address: `UNITED KINGDOM,${collectionLookup.postCode.value}`,
      postcode: collectionLookup.postCode.value,
    }),
  enabled: isManualFlow,
})

const { mutate: geocodeFullAddress, isError: isGetCoordinatesError } = useMutation({
  mutationFn: getCoordinates,
  onSuccess: (coords) => {
    markerPosition.value = coords
    initialCoordinates.value = coords
    form.setFieldValue("shippingDetails.coordinates", { lat: coords.lat, lng: coords.lng })
  },
  onError: () => {
    toast.warning("Could not find the exact address. Please adjust the pin on the map.")
  },
})

watch(coordinates, (coords) => {
  if (!coords) {
    toast.error("We couldn't find your postcode on the map. Please place the pin manually.")
    return
  }
  initialCoordinates.value = coords
  markerPosition.value = coords
  form.setFieldValue("shippingDetails.coordinates", { lat: coords.lat, lng: coords.lng })
})

watch(
  [addressSuggestions, isError, isFetched],
  ([suggestions, error, fetched]) => {
    if (fetched) {
      if (error || !suggestions?.count) {
        isManualFlow.value = true
      } else {
        isManualFlow.value = false
      }
    }
  },
  { immediate: true },
)

const formSchema = toTypedSchema(
  z.object({
    addressSelect: z
      .string()
      .optional()
      .refine(
        (addressSelect) => {
          const hasSuggestions = (addressSuggestions.value?.results?.length ?? 0) > 0
          return !!addressSelect || !hasSuggestions
        },
        {
          message: "Please select an address from the list.",
          path: ["addressSelect"],
        },
      ),
    numberOfTrees: z.number("Please select the number of trees.").min(1),
    isBigTree: z.boolean().optional(),
    shippingDetails: z.object({
      postCode: z.string().min(1, "Postcode is required"),
      addressLine1: z.string().min(1, "Address line 1 is required"),
      addressLine2: z.string().optional(),
      addressLine3: z.string().optional(),
      locality: z.string(),
      what3Words: z
        .string()
        .optional()
        .refine((val) => !val || WHAT_3_WORDS_REGEX.test(val), { message: "Invalid what3words" }),
      coordinates: z.object({
        lng: z.number(),
        lat: z.number(),
      }),
    }),
    personalDetails: z
      .object({
        title: z.string().min(1, "Title is required"),
        firstName: z.string().min(1, "First name is required"),
        lastName: z.string().min(1, "Last name is required"),
        email: z.email("Invalid email format").min(1, "Email is required"),
        emailConfirmation: z.email("Invalid email format").min(1, "Email confirmation is required"),
        phone: z
          .string()
          .min(1, { message: "Phone number is required" })
          .refine((val) => UK_PHONE_ASCII_REGEX.test(val), {
            message: "Phone number must contain only standard digits (0–9)",
          })
          .refine(() => isPhoneValid.value, {
            message: "Please enter a valid UK phone number",
          }),
      })
      .refine((data) => data.email === data.emailConfirmation, {
        message: "Email and confirmation do not match.",
        path: ["emailConfirmation"],
      }),
    itemsToCollect: z.object({
      products: z.array(
        z.object({
          sku: z.string().min(1, "SKU is required"),
          amount: z.number().min(1, "Amount must be at least 1"),
        }),
      ),
      otherDetails: z
        .string()
        .optional()
        .refine((val) => !val || NOTES_ALLOWED_CHARS_REGEX.test(val), {
          message: `Notes may only contain letters, numbers, and basic punctuation (. , ! ? - ' ( ) @ # & : ; ")`,
        }),
    }),
    contactMethods: z.object({
      selectedContactCheckbox: z.boolean().optional(),
      selectedHospiceContactCheckbox: z.boolean().optional(),
      selectedTandCCheckbox: z.literal(true, {
        message: "You must accept the Terms and Conditions to continue.",
      }),
      leadSource: z.string("Please select how you heard about us."),
    }),
    payment: z
      .object({
        prize: z
          .number({
            error: "Please enter a valid amount.",
          })
          .nonnegative({ message: "Donation cannot be negative." })
          .max(9999, { message: "Donation cannot exceed £9,999." })
          .refine((value) => value === 0 || value >= 0.3, {
            message: "Donation must be at least £0.30.",
          }),
        paymentMethodId: z.string().optional(),
        giftAid: z.boolean().optional(),
      })
      .refine((data) => !(data.prize && !data.paymentMethodId), {
        message: "You need to select a payment method if you want to donate.",
        path: ["paymentMethodId"],
      }),
  }),
)

const form = useForm({
  validationSchema: formSchema,
  initialValues: {
    shippingDetails: {
      postCode: collectionLookup.postCode.value,
    },
    personalDetails: {
      phone: "",
    },
  },
})

const { mutate: getDetails } = useMutation({
  mutationFn: getAdressDetails,
  onSuccess: (address) => {
    form.setFieldValue("shippingDetails.addressLine1", address.addressLine1)
    form.setFieldValue("shippingDetails.addressLine2", address.addressLine2)
    form.setFieldValue("shippingDetails.addressLine3", address.addressLine3)
    form.setFieldValue("shippingDetails.locality", address.locality)
  },
})

watch(
  () => collectionLookup.postCode.value,
  (newPostCode) => {
    form.resetForm({
      values: {
        shippingDetails: {
          postCode: newPostCode,
        },
      },
    })
  },
)

watch(
  () => form.values.addressSelect,
  (newSelectedAddress) => {
    if (!newSelectedAddress) return

    const suggestion = addressSuggestions.value?.results.find(r => r.format === newSelectedAddress)

    if (suggestion?.address && suggestion.lat != null && suggestion.lng != null) {
      hasExactCoordinates.value = true
      form.setFieldValue("shippingDetails.addressLine1", suggestion.address.addressLine1)
      form.setFieldValue("shippingDetails.addressLine2", suggestion.address.addressLine2)
      form.setFieldValue("shippingDetails.addressLine3", suggestion.address.addressLine3)
      form.setFieldValue("shippingDetails.locality", suggestion.address.locality)
      const coords = { lat: suggestion.lat, lng: suggestion.lng }
      markerPosition.value = coords
      initialCoordinates.value = coords
      form.setFieldValue("shippingDetails.coordinates", coords)
    } else {
      hasExactCoordinates.value = false
      getDetails({ url: newSelectedAddress })
    }
  },
)

watch(
  [
    () => form.values.shippingDetails?.addressLine1,
    () => form.values.shippingDetails?.addressLine2,
    () => form.values.shippingDetails?.addressLine3,
  ],
  ([newLine1, newLine2, newLine3]) => {
    if (form.values.addressSelect && newLine1 && !hasExactCoordinates.value) {
      const fullAddressQuery = [newLine1, newLine2, newLine3, collectionLookup.postCode.value]
        .filter(Boolean)
        .join(", ")

      geocodeFullAddress({
        address: fullAddressQuery,
        postcode: collectionLookup.postCode.value,
      })
    }
  },
)

watch(
  () => [form.values.numberOfTrees, form.values.isBigTree],
  ([numberOfTrees, isBigTree]) => {
    if (!numberOfTrees || typeof numberOfTrees !== "number") {
      form.setFieldValue("itemsToCollect.products", [])
      return
    }

    const sku = isBigTree ? model.trees.bigTree.sku : model.trees.smallTree.sku

    const products = [
      {
        sku: sku,
        amount: numberOfTrees,
      },
    ]

    form.setFieldValue("itemsToCollect.products", products)
  },
  { immediate: true },
)

const isSubmitting = ref(false)

const onSubmit = form.handleSubmit((values) => {
  const maxDistance = model.dataCollectionLocation.maxDistance

  if (isSubmitting.value) return 
  
  isSubmitting.value = true

  if (
    !isManualFlow.value &&
    !isGetManualCoordinatesError.value &&
    !isGetCoordinatesError.value &&
    markerPosition.value &&
    initialCoordinates.value &&
    maxDistance > 0
  ) {
    const distance = measureDistanceInMeters(initialCoordinates.value, markerPosition.value)
    if (distance > maxDistance) {
      openModal.value = true
      isSubmitting.value = false
      return
    }
  }

  recaptcha.execute("register").then((token) => {
    if (!window.__STATE__ || !currentHospice.value) {
      isSubmitting.value = false
      return
    }
    createOrder({
      ...values,
      hospiceId: currentHospice.value.nodeId,
      isManualFlow: isManualFlow.value,
      captchaToken: token,
      culture,
    })
  })
})

const setDonationAmount = (value: string) => {
  form.setFieldValue("payment.prize", Number(Number(value).toFixed(2)))
}

const currentHospice = computed(() => {
  return collectionLookup.hospices?.value?.[0]
})

const description = computed(() => {
  return currentHospice.value?.description || "{}"
})

const selectedAdress = computed(() => {
  return form.values.addressSelect
})

const treesOptions = computed(() => {
  const numberOfTrees = currentHospice.value?.limit ?? MAX_NUMBER_OF_TREES

  const options = Array.from({ length: numberOfTrees }, (_, i) => ({
    value: i + 1,
    text: `${i + 1}`,
  }))

  return options
})

const mapKey = window.__STATE__?.mapKey ?? undefined
const culture = window.__STATE__?.culture ?? "en-GB"
const currentPageId = window.__STATE__?.currentPageId ?? 0

const setMarker = (props: google.maps.MapMouseEvent) => {
  if (!props.latLng) {
    toast.error("Can't set marker location")
    return
  }
  markerPosition.value = { lat: props.latLng.lat(), lng: props.latLng.lng() }
  form.setFieldValue("shippingDetails.coordinates", {
    lat: props.latLng.lat(),
    lng: props.latLng.lng(),
  })
}

const handlePaymentMethodChange = (option: IPaymentOption) => {
  form.setFieldValue("payment.paymentMethodId", option.id)
}

const showPaymentOptions = computed(() => {
  const prize = form.values.payment?.prize
  return typeof prize === "number" && prize > 0
})

const onPhoneValidate = (validationObj: { valid: boolean; number: string; country?: string }) => {
  const isUK = validationObj.country === "GB"
  isPhoneValid.value = validationObj.valid && isUK
}

const sortedDonationValues = computed(() => {
  return (
    currentHospice.value?.donationAmounts
      ?.slice()
      .sort((a, b) => Number(a.value) - Number(b.value)) ?? []
  )
})
</script>
<style lang="scss" scoped>
:global(html) {
  scroll-behavior: smooth;
}

:deep {
  a {
    color: var(--primary);
  }
}

.google-map {
  width: 100%;
  height: 500px;

  .mapdiv,
  & {
    border-radius: 24px;
  }
}

.field-address {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.form-section {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.register-tree-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-wrapper {
  display: flex;
  flex-direction: column;
}

.checkbox-field {
  display: flex;
  gap: 10px;
  align-items: center;

  label {
    font-size: 0.95rem;
  }
}

.buttons {
  display: flex;
  justify-content: flex-end;
}

.buttons-donation {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.field-group {
  > div:not(.google-map) {
    flex: 1;
  }

  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 1rem;
}

.input {
  border-color: var(--input);
  border-radius: calc(var(--radius) - 2px);

  ::placeholder {
    color: var(--muted-foreground);
  }

  &[aria-invalid="true"] {
    border-color: var(--destructive);
  }
}

.input-button {
  display: flex;
  align-items: center;
  width: 250px;
  height: 50px;

  input {
    height: 100%;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  button {
    height: 100%;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}

.select-keep-in-touch {
  width: 100%;
}

.container-gift-aid {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 10px 20px;
  border-radius: 24px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.34);

  .container-gift-aid--title {
    font-weight: 700;
    font-size: 24px;
    color: var(--primary);
  }

  .container-gift-aid--subtitle {
    font-size: 1.2rem;
    color: var(--primary);
  }

  .container-gift-aid--bottom-text {
    font-size: 0.8rem;
  }

  .container-gift-aid--explanation {
    font-size: 0.8rem;
    font-style: italic;
  }
}

.charity-info {
  display: flex;
  flex-direction: column;
  padding-bottom: 12px;
  padding-left: 12px;

  .title-wrapper {
    display: flex;
    flex-direction: column;
    gap: 12px;
    justify-content: center;
    align-items: center;
    padding-bottom: 12px;
  }

  .image-wrapper {
    height: auto;
    width: 100%;

    img {
      height: auto;
      width: 100%;
      display: block;
    }
  }
}

@media (min-width: 768px) {
  .charity-info {
    .title-wrapper {
      .image-wrapper {
        height: 100px;
        width: auto;

        img {
          height: 100%;
          width: auto;
        }
      }
    }
  }

  .field-group {
    flex-direction: row;

    > div {
      flex: 1;
    }
  }

  .select-keep-in-touch {
    min-width: 400px;
  }
}
</style>
